import { Link, useHistory } from 'react-router-dom';
import React, {useState} from 'react';
import "./Login.css";
import { auth } from './firebase';

function Login() {
    const history = useHistory();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
      
    const signIn = e =>{
        e.preventDefault();

        auth.signInWithEmailAndPassword(email, password)
        .then(auth => {
                history.push('/')
        })
        .catch(error => alert(error.message))
        //some fauncy firebase login shittt....
    }
    const register = e => {
        e.preventDefault();
        auth.createUserWithEmailAndPassword(email, password)
        .then((auth) => {
            if(auth){
                history.push('/')
            }
        })
        .catch(error => alert(error.message))
    //some fauncy firebase register shittt....

    }

    return (
        <div className="login">
            <Link to="/">
            <img className="login_logo" 
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1024px-Amazon_logo.svg.png" alt=""/>
            </Link>
            <div className="login_container">
                <h1>Sing-in</h1>
                <form >
                    <h5>E-mail</h5>
                    <input type="text" 
                    value={email} onChange={e => setEmail(e.target.value)}/>

                    <h5>Password</h5>
                    <input type="password"
                    value={password} onChange={e => setPassword(e.target.value)}/>

                    <button type="submit" onClick={signIn} className="login_singInButton" 
                    >Sign In</button>
                </form>
                <p>
                    By signing-in you agree to Amazon's
                    Conditions of Use & Sale. Please see
                    our Privacy Notice, our Cookies Notice
                    and our Interest-Based Ads Notice
                </p>
                <button onClick={register} type="submit" className="login_registerButton">Create Your Amazon Account</button>
            </div>
        </div>
    )
}

export default Login;
